import {
	RULE_MESSAGE_TYPE,
	RULE_SEVERITY,
	RULE_TYPE
} from './enums';

export class OrderRulesModel {
	created?: string;
	deferredRulesIndicator?: boolean;
	executedRuleSets?: string[];
	externalId?: string;
	ruleSetName?: string;
	status?: any[];
	violations?: RuleModel[];

	constructor() {
		this.ruleSetName = '';
		this.status = [];
		this.violations = [];
	}
}

export class AvailableRulesetModel {
	id: string;
	name: string;
	displayText: string;
	description?: string;
	active?: boolean;
	visibility?: boolean;
	private?: boolean;
	createdBy?: number;
	createdByName?: string;
	created?: Date;
	updated?: Date;
	updatedBy?: number;
	schemaVersion?: any;
	form?: any;

	constructor() {
		this.id = '';
		this.name = '';
		this.displayText = '';
	}
}

export class RuleModel { // ViolationModel
	availableStips: StipModel[];
	category: string;
	cvSortId?: number;
	definitionType: number;
	dependsOnEvent?: any;
	displayText: string;
	formSectionName: string;
	isDeferred?: boolean;
	hasFieldReferenced?: boolean;
	message: string;
	messageType: RULE_MESSAGE_TYPE;
	notes: RuleCommentModel[];
	stips: StipModel[];
	output: any;
	targets: any[];
	primaryTargets: any[];
	resolver: any;
	ruleName: string;
	ruleSetDisplayText: string;
	ruleSetId: string;
	ruleSetName: string;
	ruleType: string;
	reason?: string;
	severity: string;
	sortId?: number;
	state: string;
	status: number | string;
	uiSection: string;
	canAddStips?: boolean;
	multipleUiSections: any[];
	variables?: any;
	wasResolved?: boolean;
}

export class StipModel {
	id?: string;
	stipId?: string;
	stipulation: string;
	ruleName?: string;
	created?: Date;
	updated?: Date;
	overwritten?: boolean;
}

export class RuleCommentModel {
	id?: string;
	note?: string;
	created?: Date;
	updated?: Date;
	targets?: any[];
}

export class RuleLogModel {
	title: string;
	modifiedBy: string;
	section: any; // string
	date: number;
}

export class RuleCreateModel {
	category: string;
	displayText: string;
	message: string;
	messageType: RULE_MESSAGE_TYPE;
	ruleType: RULE_TYPE;
	severity: RULE_SEVERITY;
	sortId: number;
	targets: any[];
	// optional;
	primaryTargets?: any[];
	uiSection?: string;
	formSection?: string;

	constructor() {
		this.category = 'Unknown';
		this.displayText = '';
		this.message = '';
		this.messageType = null;
		this.ruleType = RULE_TYPE.CEHCKLIST;
		this.severity = null;
		this.sortId = 0;
		this.targets = [];
		this.uiSection = 'NONE';
		this.formSection = 'NONE';
	}
}

// RuleEngineComponent Service
export class RuleComponentInitModel {
	defaultRuleSet: string;
}

export class RuleComponentDataInput {
	rules?: RuleModel[];
	uiSection: string;
	targets: {
		data: string[];
		primary: string[];
	};
	openContent?: boolean;

	constructor() {
		this.rules = [];
		this.uiSection = null;
		this.targets = {
			data: [],
			primary: []
		};
		this.openContent = false;
	}
}

export class RulesComponentSharedData {
	data: RuleComponentDataInput;
	orderDetail: any;
	currentUser: any;
	rules: any;
	rulesNotifications: any[];
	rulesSelected: any;
	rulesEvents: any[];
}

export class RuleComponentDictionary {
	uiSections: string[];
	formSections: string[];
	formType: string;
	ruleBase: RuleComponentDictionaryRuleBase;

	constructor() {
		this.uiSections = [];
		this.formSections = [];
		this.formType = '';
		this.ruleBase = {};
	}
}

export interface RuleComponentDictionaryRuleBase {
	[uiSection: string]: number;
}
